import { render } from "./Server Down.vue?vue&type=template&id=1a7c832a"
import script from "./Server Down.vue?vue&type=script&lang=js"
export * from "./Server Down.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__